export default __webpack_public_path__ + "static/media/R57SR51.81b481ee.png";